module.exports = __webpack_public_path__ + "media/unauthenticated/signin-accountant-49ded153.png";